export default {
  "content": "<path clip-rule=\"evenodd\" d=\"M8 16A8 8 0 108 0a8 8 0 000 16zm3.707-9.293a1 1 0 00-1.41-1.418L11 6l-.703-.711-.002.002-.006.006-.026.025-.097.096-.354.35A724.7 724.7 0 008.67 6.903c-.56.556-1.174 1.17-1.677 1.677L5.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0z\" fill=\"#ff00cb\" fill-rule=\"evenodd\"/>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "fill": "none",
    "height": "16",
    "width": "16",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};